import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import List from "views/broadcast/List"
const SimpleModal = ({ show, handleClose, title, message ,clearInput,setIsSuccess,subject,uploadImage,fileType,attachment}) => {
const [sendMessage,setSendMessage]=useState(false)
    return (
      <Modal scrollable={true}  show={show} onHide={handleClose} centered>
        <Modal.Header closeButton>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
  
        <Modal.Body className="px-0" style={{minHeight: 300}}>
          <List 
          message={message} 
          sendMessage={sendMessage} 
          handleClose={handleClose} 
          setSendMessage={setSendMessage} 
          clearInput={clearInput}
          setIsSuccess={setIsSuccess}
          subject={subject}
          uploadImage={uploadImage}
          fileType={fileType}
          attachment={attachment}
          />
          </Modal.Body>
  
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={()=>setSendMessage(true)}>
            Send
          </Button>
        </Modal.Footer>
      </Modal>
    );
  };
  
  export default SimpleModal;